if (!customElements.get('product-upsell')) {

    class ProductUpsell extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector('.product-upsell__slider.splide');

        const splideUpsell = new Splide(this.slider, {
          arrows: true,
          pagination: false,
          mediaQuery: 'max',
          perPage: 3,
          gap: '1rem',
          focusableNodes: 'a, button, textarea, input:not([type="radio"]), select, iframe',
          slideFocus: false,
          breakpoints: {
            990: {
              gap: 0,
              perPage: 1,
              fixedWidth: '26.1rem',
              height: '41.2rem',
            },
          }
        })

        splideUpsell.on( 'mounted', () => {
          splideUpsell.Components.Slides.forEach(component => {
            const sizeVariantRadios = component.slide.querySelectorAll('label.visible-size input[type="radio"]')
            sizeVariantRadios.forEach(label => {
              label.addEventListener('keydown', (e) => e.stopPropagation())
            });
          })
        });

        splideUpsell.mount();
      }
    }

    customElements.define('product-upsell', ProductUpsell);
}
